// ADDED: Salary Advance Bracket Table
import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';

const SalaryAdvanceDeductionBracketTable = ({ 
    data, 
    onEdit, 
    currentPage,
    setCurrentPage
}) => {
  const headers = [
    "ID", 
    "Employee Type", 
    "Min Amount", 
    "Max Amount", 
    "Deduction", 
    "Bonus Deduction", 
    "Status", 
    "Actions"
  ];

  const accessors = [
    "id", 
    "employeeTypeDescription", 
    "minAmount", 
    "maxAmount", 
    "deductionAmount", 
    "bonusDeductionAmount", 
    "isActive", 
    "actions"
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Salary Advance Bracket List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default SalaryAdvanceDeductionBracketTable;